import * as React from "react";

import { cn } from "../../lib/utils.ts";

function Label({ className, ...props }: React.ComponentProps<"label">) {
    return (
        // oxlint-disable-next-line jsx-a11y/label-has-associated-control -- htmlFor is passed via {...props} spread
        <label data-slot="label" className={cn("flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50", className)} {...props} />
    );
}

export { Label };
